// extracted by mini-css-extract-plugin
export default {"invalidStipulationsCardContainer":"_invalid-stipulations-card_invalidStipulationsCardContainer__WWmEu","tabContent":"_invalid-stipulations-card_tabContent__tVGbz"};